module.exports = __webpack_public_path__ + "img/antes_despues_22.0f50def5.png";